import React from 'react';
import GenericCrudPage from '../../components/GenericCrudPage/GenericCrudPage';
import {softwareProductColumns} from './datatableConfig';
import {softwareProduct_URL} from "../../constants/urlConfig";

const SoftwareProduct = () => <GenericCrudPage
    title="Software Product"
    helptip="Administration panel for managing software products that are being licenced."
    linkFetch={softwareProduct_URL}
    deleteAction={true}
    editAction={true}
    actionsEnabled={true}
    addModal={true}
    columns={softwareProductColumns()}
    expandRow={true}
    link={softwareProduct_URL}
/>;

export default SoftwareProduct;